import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";

const NotFound = () => {
  return (
    <>
      <Header />
      <div className="min-height60 container flex-middle">
        <h1>Page not found</h1>
        <Link to="/home">
          <button className="es-link colored font-16" type="button">
            <svg viewBox="0 0 54 128" height="16" width="11">
              <path d="M1 61l45-45 7 7-38 38 38 38-7 7z"></path>
            </svg>
            &nbsp;Back To Home
          </button>
        </Link>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;